// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"0522565bb3852949","6831":"51b6d7f3af67ec9d","8503":"c3d40cbd93488b48","9683":"5b61e0a18d81d33d"}[chunkId] + ".js";
};